import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem("language");
    return storedLanguage === "en" || storedLanguage === "ar"
      ? storedLanguage
      : "ar";
  });
  const [direction, setDirection] = useState(() =>
    language === "ar" ? "rtl" : "ltr"
  );

  const changeLanguage = (lang) => {
    if (lang !== "en" && lang !== "ar") {
      return;
    }

    setLanguage(lang);
    setDirection(lang === "ar" ? "rtl" : "ltr");
  };

  useEffect(() => {
    localStorage.setItem("language", language);
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", language);
    window.dispatchEvent(
      new CustomEvent("languageChange", { detail: { language } })
    );
  }, [direction, language]);

  const value = useMemo(
    () => ({ language, direction, changeLanguage }),
    [direction, language]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
